export const COUNTRY = "country";
export const COMPANY_NAME = "companyName";
export const STREET_ADDRESS_1 = "streetAddress1";
export const CITY = "city";
export const STATE = "state";
export const ZIP_CODE = "zipCode";
export const PHONE_NUMBER = "phoneNumber";

export const COMPANY_NAME_MANDATORY = "Company Name is mandatory";
export const STREET_ADDRESS_1_MANDATORY = "Street Address is mandatory";
export const ZIP_CODE_MANDATORY = "Postal Code is mandatory";
export const ZIP_CODE_INVALID = "Please enter a valid Postal Code";
export const COUNTRY_MANDATORY = "Country is mandatory";
export const STATE_MANDATORY = "State/Province is mandatory";
export const CITY_MANDATORY = "City is mandatory";
export const PHONE_NUMBER_MANDATORY = "Phone Number is mandatory";
export const PHONE_NUMBER_INVALID = "Please enter a valid Phone Number";

export const objError = {
    companyName: {
        status: false,
        message: "",
    },
    streetAddress1: {
        status: false,
        message: "",
    },
    city: {
        status: false,
        message: "",
    },
    country: {
        status: false,
        message: "",
    },
    state: {
        status: false,
        message: "",
    },
    zipCode: {
        status: false,
        message: "",
    },
    phoneNumber: {
        status: false,
        message: "",
    }
};

export const POSTAL_CODE_FORMAT = /^[A-Za-z0-9\s]+$/;

export const MAX_FILE_SIZE = 5 * 1024 * 1024;